import axiosAutoCheck from "global/helpers/axiosAutoCheckIn";
import {
  MEDICO_POR_MATRICULA,
  MEDICO_POR_MATRICULA_FAIL,
  MEDICO_POR_MATRICULA_SUCCESS,
  SELECCIONA_MEDICO_LABO,
  SELECCIONA_MEDICO_LABO_FAIL,
  SELECCIONA_MEDICO_LABO_SUCCESS,
  SELECCIONA_MEDICO_TURNO,
  SELECCIONA_MEDICO_TURNO_FAIL,
  SELECCIONA_MEDICO_TURNO_SUCCESS,
} from "../ActionTypes";

export const wsGetMedicoPorMatricula = (matricula, nextStep) => (dispatch) => {
  dispatch({ type: MEDICO_POR_MATRICULA });

  axiosAutoCheck().then((respuesta) => {
    respuesta
      .get(`/MedicoSolicitante/PorMatricula/${matricula}`)
      .then((resp) => {
        dispatch({ type: MEDICO_POR_MATRICULA_SUCCESS, payload: resp.data });
        if (nextStep) {
          nextStep(true);
        }
      })
      .catch((err) => {
        dispatch({ type: MEDICO_POR_MATRICULA_FAIL, payload: err });
        if (nextStep) {
          nextStep(false);
        }
      });
  });
};

export const wsPutSeleccionarMedicoLabo =
  (idProtocolo, medSolicitante, idPacFamiliar, nextStep) => (dispatch) => {
    dispatch({ type: SELECCIONA_MEDICO_LABO });

    axiosAutoCheck().then((respuesta) => {
      respuesta
        .put(
          `/laboratorio/medicoSoliciante/${idProtocolo}/${medSolicitante}/${
            !idPacFamiliar ? "" : idPacFamiliar
          }`
        )
        .then((resp) => {
          dispatch({ type: SELECCIONA_MEDICO_LABO_SUCCESS });
          if (nextStep) {
            nextStep(true);
          }
        })
        .catch((err) => {
          dispatch({ type: SELECCIONA_MEDICO_LABO_FAIL });
          if (nextStep) {
            nextStep(false);
          }
        });
    });
  };

export const wsPutSeleccionaMedicoTurnoQr =
  (idTurno, medSolicitante, nextStep) => (dispatch) => {
    dispatch({ type: SELECCIONA_MEDICO_TURNO });

    axiosAutoCheck().then((respuesta) => {
      respuesta
        .put(`/turno/medicoSolicitanteQr/${idTurno}/${medSolicitante}`)
        .then((resp) => {
          dispatch({ type: SELECCIONA_MEDICO_TURNO_SUCCESS });
          if (nextStep) {
            nextStep(true);
          }
        })
        .catch((err) => {
          dispatch({ type: SELECCIONA_MEDICO_TURNO_FAIL });
          if (nextStep) {
            nextStep(false);
          }
        });
    });
  };
